import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import { deleteTeams } from '../../store/TeamManagementActions'
import DeleteTeam, { ICreateTeam, ICreateTeamDispatchProps } from './DeleteTeam'

const mapStateToProps = (state: IGlobalState, ownProps: ICreateTeam) => ownProps

const mapDispatchToProps: ICreateTeamDispatchProps = {
  deleteTeams,
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteTeam)
